import GenericRequest, { METHOD_PUT } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export class NotificationReadTask extends GenericRequest {

    _request; // NotificationReadRequest

    constructor(request) {
        super(METHOD_PUT, ApiEndpoints.NOTIFICATIONS_MARK_READ);
        this._request = request;
    }

    overrideRequest() {
        return this._request.body();
    }
}



// WEBPACK FOOTER //
// ./src/app/messages-notifications/notifications/preview-list/notification-read/NotificationReadTask.js